require('../styles/main.css');

import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';

import doHeader from './modules/header';
import navToggle from './modules/nav';
import doModal from './modules/modal';
import doOptions from './modules/options';
import scroll2 from './modules/scrollto';
import scrollReveal from './modules/scroll-reveal';
import doGallery from './modules/gallery';
import observer from './modules/observer';
import ScrollSpy from './modules/scrollspy';
// import initGravityForms from './modules/gravity-forms';

import initInfiniteBlog from './modules/infinite-blog';

let pendingHash = null;

const initDetectAspectWhenPresent = function () {
  const container = document.querySelector('.detect-aspect');
  if (!container) return;

  import('./modules/detect-aspect').then((module) => {
    if (module.default) {
      module.default(container);
    }
  });
};

const initReadMoreWhenPresent = function () {
  if (!document.querySelector('.read-more[data-display-elements]')) return;

  import('./modules/read-more').then((module) => {
    if (module.default) {
      module.default();
    }
  });
};

const initAccordionWhenPresent = function () {
  if (!document.querySelector('[data-accordion="true"]')) return;

  import('./modules/accordion').then((module) => {
    if (module.default) {
      module.default();
    }
  });
};

const initHeroLogoScrollWhenPresent = function () {
  if (!document.querySelector('.hero-module')) return;

  import('./modules/hero-logo-scroll').then((module) => {
    if (module.default) {
      module.default.init();
    }
  });
};

const initWobblyWhenPresent = function () {
  if (!document.querySelector('.wobbly, .logo-main--hero')) return;

  import('./modules/wobbly').then((module) => {
    if (module.default) {
      module.default();
    }
  });
};



const init = function () {

  window.scrollTo(0, 0);

  if (pendingHash) {
    const target = document.getElementById(pendingHash);

    if (target) {
      const offset = target.getBoundingClientRect().top - 25; // 25 offset
      window.scrollTo(0, offset);
    }

    pendingHash = null;

    if (window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }
  // header colour options
  const elements = document.querySelectorAll('section');
  if (elements.length > 0) {
    doOptions.doTheOptions(elements);
  }


  // Header show/hide on scroll
  doHeader.doTheHeader();

  // Navigation toggle (mobile menu)
  navToggle.init();

  // Modal open/close functionality
  doModal.init();

  // Scroll-to links (next section, anchor links)
  scroll2.init();

  // Scroll reveal animations
  scrollReveal.init();

  // Image galleries (Swiper)
  const galleries = document.querySelectorAll('.gallery');
  galleries.forEach((gallery) => {
    const slides = gallery.querySelectorAll('.swiper-slide');
    if (slides.length > 1) {
      doGallery(gallery);
    }
  });

  // Video observer (play/pause on visibility)
  observer.init();

  // Detect image aspect ratios in content
  initDetectAspectWhenPresent();


  // Read more expanders for long content blocks
  initReadMoreWhenPresent();

  // Accordion interactions
  initAccordionWhenPresent();

  // Hero/logo scroll animation
  initHeroLogoScrollWhenPresent();

  // Pointer-reactive wobble for reusable ".wobbly" elements.
  initWobblyWhenPresent();

  // Blog infinite scroll
  initInfiniteBlog();


  // Scroll Spy 
  ScrollSpy.init();

  // Gravity Forms: re-trigger post render hooks after Swup swaps
  // initGravityForms();

};

const swup = new Swup({
  // Every configured container must exist in both the current and incoming DOM.
  containers: ['#header', '#main'],
  plugins: [new SwupBodyClassPlugin()],
  // cache: true,
});

swup.hooks.on('visit:start', (visit) => {
  // console.log(visit);

  const toHash = visit.to.hash;
  if (toHash) {
    const hash = toHash.split('#')[1];
    if (hash) {
      pendingHash = hash;
    }
  }
});

swup.hooks.before('content:replace', () => {
  observer.disconnect();
  doOptions.destroyOptions();
});

swup.hooks.on('page:view', () => {
  init();
});

init();
